import { Link } from 'react-router-dom';
import { useAuth } from '../auth';
import { GUIDE_PDF } from '../components/Help';
import { Icon, type IconName } from '../components/Icon';

type Tile = { to: string; icon: IconName; title: string; text: string };
const TILES: Tile[] = [
  { to: '/lots/new', icon: 'plus', title: 'Create lot', text: 'Scan a label, pick the product, photos, location' },
  { to: '/lots/new?tour=1', icon: 'book', title: 'How to list', text: 'Replay the Create lot tour' },
  { to: '/find', icon: 'search', title: 'Find lot', text: 'Scan a lot label to see it and where it is' },
  { to: '/move', icon: 'pin', title: 'Move lots / bins', text: 'Scan a location, then scan lots or bins into it' },
  { to: '/bins', icon: 'bin', title: 'Bins', text: 'Pack lots into bins for the store, print bin labels and packing lists' },
  { to: '/lots', icon: 'list', title: 'All lots', text: 'Search, filter and review lots' },
  { to: '/products', icon: 'box', title: 'Products', text: 'Search, add and edit products' },
  { to: '/imports/new', icon: 'upload', title: 'Import products', text: 'Add new products from the master list (Excel) or a CSV' },
  { to: '/labels', icon: 'tag', title: 'Lot labels', text: 'Issue and print 1.5″ × 1″ lot labels' },
];
const RECEIVING_TILES: Tile[] = [{ to: '/receiving', icon: 'inbox', title: 'Receiving', text: 'Process a manifest: retail, auction or garbage' }];
const ADMIN_TILES: Tile[] = [{ to: '/web-data', icon: 'globe', title: 'Costco data', text: 'Titles, descriptions and photos from Costco websites' }];

export function HomePage() {
  const { user } = useAuth();
  return (
    <div>
      <h1>Hello, {user?.displayName}</h1>
      <div className="tiles">
        {[...(user?.canReceive ? RECEIVING_TILES : []), ...TILES, ...(user?.role === 'admin' ? ADMIN_TILES : [])].map((t) => (
          <Link key={t.to} to={t.to} className="tile">
            <span className="tile-icon">
              <Icon name={t.icon} size={22} />
            </span>
            <span className="tile-title">{t.title}</span>
            <span className="tile-text">{t.text}</span>
          </Link>
        ))}
      </div>
      <p>
        <a href={GUIDE_PDF} target="_blank" rel="noreferrer" className="icon-link">
          <Icon name="file" size={16} /> Lister work instructions (printable PDF)
        </a>
      </p>
      <p className="muted small">Auction batches &amp; exports (stage 2) and sales import &amp; pickup (stage 3) are not built yet.</p>
    </div>
  );
}
